import { useCallback } from 'react';

import { useKnownAvailableParams } from '@change-corgi/core/react/router';

import type { Task } from '../../../../types';

export function useGetHref() {
	const { slug } = useKnownAvailableParams<{ slug: string }>();

	return useCallback(
		({ name }: { name: Task['name'] }) => {
			switch (name) {
				case 'promote_petition': {
					return `/p/${slug}/promote`;
				}
				case 'post_an_update': {
					return `/p/${slug}/u/new`;
				}
				default: {
					return undefined;
				}
			}
		},
		[slug],
	);
}
